export default "__VITE_ASSET__qcPtJvAk__"